














import Vue from 'vue'
import { Component, Emit, Prop } from 'vue-property-decorator'

import CouponPage from '@spa/components/pages/mypage/coupon/models/coupon-page'

@Component
export default class CouponPagination extends Vue {
  @Prop({ required: true })
  page: CouponPage

  @Prop({ required: true })
  shouldShowNext: boolean

  get shouldShow(): boolean {
    return this.shouldShowPrevious || this.shouldShowNext
  }

  get shouldShowPrevious(): boolean {
    return this.page.pageNumber > 1
  }

  onPreviousPageClick() {
    this.newPageSelected(this.page.pageNumber - 1)
  }

  onNextPageClick() {
    this.newPageSelected(this.page.pageNumber + 1)
  }

  @Emit()
  newPageSelected(_pageNumber: number) {
    // Do nothing
  }
}
